import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SAMPLE_PERSONAS, SAMPLE_PERSONA_IDS } from '../../lib/numerology/samplePersonas';
import NumerologyHubHero from '../../components/numerology/NumerologyHubHero';

const PAGE_TITLE = 'Numerology | Astral Moon Magic';

export default function NumerologyHubPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = PAGE_TITLE;
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="amm-hub-page">
      <NumerologyHubHero />

      <section className="amm-hub-course" aria-labelledby="learn-heading">
        <h2 id="learn-heading" className="amm-hub-course__title">
          Learn numerology
        </h2>
        <p className="amm-hub-course__lede">
          The study area is a seven-module path: foundations and core numbers, number meanings, secondary positions,
          personal timing, life cycles, and a full reading capstone—one place to work through the method in order.
        </p>
        <p className="amm-hub-course__path">
          Foundations → Calculations → Meanings → Timing → Reading
        </p>
        <div className="amm-hub-course__cta">
          <Link className="amm-button" to="/numerology/study">
            Open study
          </Link>
        </div>
      </section>

      <section className="amm-hub-samples" aria-labelledby="samples-heading">
        <h2 id="samples-heading" className="amm-hub-samples__title">
          Example reports
        </h2>
        <p className="amm-hub-samples__body">
          These are full report layouts built from example birth data. They show how core numbers, timing, and synthesis
          read together—not isolated definitions.
        </p>
        <div className="amm-hub-samples__names">
          <Link
            className="amm-hub-samples__name"
            to={`/numerology/report?sample=${encodeURIComponent(SAMPLE_PERSONA_IDS.POE)}`}
          >
            {SAMPLE_PERSONAS[SAMPLE_PERSONA_IDS.POE].displayName}
          </Link>
          <Link
            className="amm-hub-samples__name"
            to={`/numerology/report?sample=${encodeURIComponent(SAMPLE_PERSONA_IDS.CURIE)}`}
          >
            {SAMPLE_PERSONAS[SAMPLE_PERSONA_IDS.CURIE].displayName}
          </Link>
        </div>
        <div className="amm-hub-samples__cta">
          <Link className="amm-button-secondary" to="/numerology/study/samples">
            View sample reports
          </Link>
        </div>
      </section>

      <p className="amm-hub-disclaimer amm-hub-disclaimer--edu">
        This course and report are provided for educational and informational purposes only. Numerology and spiritual
        guidance are interpretive tools. We do not guarantee outcomes, financial results, or personal transformation.
      </p>

      <section className="amm-hub-report" aria-labelledby="report-heading">
        <h2 id="report-heading" className="amm-hub-report__title">
          Your personal report
        </h2>
        <p className="amm-hub-report__body">
          Enter your birth details to generate your own report and review your core numbers and patterns in one place.
        </p>
        <p className="amm-hub-disclaimer amm-hub-disclaimer--sale">
          By purchasing digital content, you consent to immediate delivery and acknowledge that you waive your 14-day EU
          withdrawal right once access is granted.
        </p>
        <div className="amm-hub-report__cta">
          <Link className="amm-button" to="/numerology/report">
            Create report
          </Link>
        </div>
        <p className="amm-hub-disclaimer amm-hub-disclaimer--sale amm-hub-disclaimer--sale-after-cta">
          All sales are final due to the digital nature of this product.
        </p>
      </section>
    </div>
  );
}
